import Vue from 'vue'
import axios from 'axios'
import { robotTimeAlarm } from './alarm'
import i18n from "@/app/i18n/global.js";

//添加一个请求拦截器
axios.interceptors.request.use(function (config) {
    //为请求头对象,添加token验证的Authorization字段
    config.headers.HTTP_ACCESS_TOKEN = window.sessionStorage.getItem('token');
    config.headers.service = '1';
    config.headers.os = 'zd_pc_main';
    config.headers.version_code = '24073001';
    config.headers.app_version = '1.1.0';
    config.headers["accept-language"] = i18n.locale === "zh-CN" ? "zh" : "en";
    config.metadata = { startTime: new Date() }
    return config;
}, function (err) {
    //处理响应的错误信息
})

// 添加一个响应拦截器
axios.interceptors.response.use(function (res) {
    // console.log(res);
    // 在这里对返回的数据进行处理
    res.config.metadata.endTime = new Date();
    if (process.env.NODE_ENV !== 'development') {
        // robotTimeAlarm(res);
    }
    return res.data;
}, function (err) {
    // console.log(err.response);
    err.config.metadata.endTime = new Date();
    throw err.response;
    //处理响应的错误信息
});

Vue.prototype.$http = axios;